export default "__VITE_ASSET__BolnXf9V__"